import styles from "../orders-page.module.scss";
import { Space, Table, Typography } from "antd";
import { IOrderedItem } from "@drone-parts.garphild.pro/interfaces";
import ShortName from "../components/short-name";
import { PartTypeSelector } from "../../../components/part-type-selector";
import ordersStorage from "../../../storages/orders.storage";
import { observer } from "mobx-react-lite";
import { useState } from "react";

function Items() {
  const [currentPage, setCurrentPage] = useState(1);
  return (
    <Table
      rowKey="id"
      className={styles['tableMiddle']}
      columns={[
        // {
        //   title: "_id",
        //   dataIndex: "_id",
        //   key: "_id",
        //   render: (value: string, rowData: IOrderedItem) => {
        //     return (
        //       <Space direction={"vertical"}>
        //         <Typography>{value}</Typography>
        //       </Space>
        //     )
        //   }
        // },
        {
          title: "Marketplace",
          dataIndex: "sellerId",
          key: "sellerId",
          render: (value: string, row) => {
            return (
              <Space direction={"vertical"}>
                <Typography>{value || '-'}</Typography>
                <Typography>{row.marketplaceId}</Typography>
                <Typography>{row.orderStatus}</Typography>
              </Space>
            )
          }
        },
        {
          title: "Order Id",
          dataIndex: "orderNumber",
          key: "orderNumber",
          render: (orderNumber: string, row: IOrderedItem) => {
            const trackingNumbers = row.trackingNumbers || [];
            return (
              <Space direction="vertical">
                {row.marketplaceId === 'aliexpress' ?
                  <>
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      href={`https://www.aliexpress.com/p/order/detail.html?orderId=${orderNumber}`
                      }>
                      {orderNumber}
                    </a>
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      href={`https://www.aliexpress.com/p/tracking/index.html?tradeOrderId=${orderNumber}`
                      }>
                      tracking
                    </a>
                    <div>{trackingNumbers?.join(", ")}</div>
                  </>
                  : orderNumber
                }
              </Space>
            );
          }
        },
        {
          title: "Item name",
          dataIndex: "shortName",
          key: "shortName",
          render: (value: string, rowData: IOrderedItem) => {
            return (
              <Space direction={"vertical"}>
                <ShortName orderedItem={rowData} />
                <PartTypeSelector
                  partType={rowData.partTypes ? rowData.partTypes : []}
                  onChange={(value) => ordersStorage.setItemField(rowData.orderId, rowData.marketplaceId!, rowData._id, value, 'partTypes')}
                />
              </Space>
            )
          }
        },
        {
          title: 'Total',
          dataIndex: 'itemPrice',
          key: 'itemPrice',
          render: (value: number, row) => {
            const used = row.used?.reduce((acc, usedItem) => {
              return acc + (usedItem.quantity || 0);
            }, 0) || 0;
            return (
              <Space direction={"vertical"}>
                <Typography>{row.itemVariant}</Typography>
                <Typography>{row.itemCurrency} {value.toFixed(2)}</Typography>
                <Typography>Ordered: {row.itemQuantity} x {row.unitsInPackage} ({row.itemQuantity! * row.unitsInPackage!})</Typography>
                <Typography>In stock: {(row.inStock || 0) - used} / {used} / {row.inStock} </Typography>
              </Space>
            )
          }
        }
      ]}
      dataSource={ordersStorage.items.filter((item) => {
        return ((item?.partTypes?.length || 0) === 0)
      })}
      rowClassName={(item: IOrderedItem) => {
        const used = item.used?.reduce((acc, usedItem) => {
          return acc + usedItem.quantity;
        }, 0) || 0;
        if (used > (item.inStock || 0)) {
          return styles['overused'];
        }

        const inStock = item.received;
        const notInStock = !item.received;

        if (inStock && notInStock) {
          return styles['partially-in-stock'];
        }
        if (inStock) {
          return styles['in-stock'];
        }
        return styles['not-in-stock'];
      }}
      pagination={
        {
          position: ['bottomCenter'],
          // pageSize: 20,
          current: currentPage,
          onChange: (page) => {
            setCurrentPage(page);
          }
        }
      }
      expandable={{
        expandedRowRender: (order,  index, indent, expanded) => {
          return (
            // expanded && <DetailTable order={order} key={order._id} />
            null
          );
        },
        rowExpandable: (record) => {
          // if (mode === 'uncategorized') {
          //   return record.orderItems?.some((item) => !item.category || !item.part);
          // }
          //
          // return record.orderItems?.length > 0;
          return false
        },
        // defaultExpandedRowKeys: expandedRowKeys,
        // expandedRowKeys: expandedRowKeys,
        onExpandedRowsChange: (expandedRows) => {
          console.log("expandedRows", expandedRows);
        },
        onExpand: (expanded, record) => {
          // expandRow(record._id, expanded);
        }
      }}
    />
  );
}

export default observer(Items);
